import React, { memo, useContext, useMemo } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import SelectorControllableReanimated from 'design-system/SelectorControllableReanimated';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
export const SAVE_TAB_SECTIONS = [
    { name: 'Pots', width: 64 },
    { name: 'Cashback', width: 101 },
    { name: 'Opportunities', width: 131 },
];
const SaveTabSelectorControllable = ({ width, scrollX, setSelection, selectorScrollViewRef, shouldSaveTabHeaderScroll, }) => {
    const isInWalkthrough = useContext(WalkthroughContext);
    const { paddingHorizontal } = useAppFrameDimensions(true);
    const sections = useMemo(() => SAVE_TAB_SECTIONS.map((item) => ({
        id: item.name,
        text: item.name,
        name: item.name,
        width: rem(item.width),
    })), []);
    return (<ScrollView horizontal ref={selectorScrollViewRef} showsHorizontalScrollIndicator={false} scrollEnabled={shouldSaveTabHeaderScroll} contentContainerStyle={{
            paddingHorizontal: paddingHorizontal + (isInWalkthrough ? 0 : rem(16)),
        }}>
      <SelectorControllableReanimated scrollX={scrollX} sections={sections} screenWidth={width} setSelection={setSelection} selectorStyle={styles.selectorStyle} itemContainerStyle={styles.itemContainerStyle}/>
    </ScrollView>);
};
const styles = StyleSheet.create({
    itemContainerStyle: {
        margin: 0,
        padding: 0,
    },
    selectorStyle: {
        margin: 0,
        padding: 0,
        borderRadius: rem(8),
        justifyContent: 'center',
    },
});
export default memo(SaveTabSelectorControllable);
